import Modal from "react-bootstrap/Modal";
import { useState, useEffect } from "react";

import { Button, Input } from "../..";

import styles from "./styles.module.css";

const toBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => resolve(fileReader.result);
    fileReader.onerror = (error) => reject(error);
  });
};

export const StoreModal = (props) => {
  const {
    isOpen,
    closeModal,
    editMode,
    defaultValues,
    handleEditItem,
    handleCreateItem,
    openElement,
    error,
    loading

  } = props;

  const [values, setValues] = useState({
    name: "",
    desc: "",
    price: "",
    category: "",
    icon: "",
  });

  const [iconFileName, setIconFileName] = useState("");

  // Update values when defaultValues changes (for edit mode)
  useEffect(() => {
    if (editMode && defaultValues) {
      setValues({
        name: defaultValues.name || "",
        desc: defaultValues.desc || "",
        price: defaultValues.price || "",
        category: defaultValues.category || "",
        icon: defaultValues.icon || "",
      });
    } else if (!editMode) {
      setValues({
        name: "",
        desc: "",
        price: "",
        category: "",
        icon: "",
      });
    }
  }, [editMode, defaultValues]);

  const handleInputChange = (e, key) => {
    setValues((prevValues) => {
      return {
        ...prevValues,
        [key]: e.target.value,
      };
    });
  };

  const handleIconChange = async (e) => {
    const iconFile = e.target.files[0];
    setIconFileName(iconFile.name);

    const iconBase64 = await toBase64(iconFile);

    setValues((prevValues) => {
      return {
        ...prevValues,
        icon: iconBase64,
      };
    });
  };

  return (
    <>
      {openElement}

      <Modal show={isOpen} onHide={closeModal} dialogClassName={styles.modal}>
        <Modal.Header closeButton />

        <Modal.Body>
          <h4>{editMode ? "Edit Item" : "New Item"}</h4>

          <Input
            label="Name"
            value={values.name}
            onChange={(e) => handleInputChange(e, "name")}
            disabled={loading}
          />

          <Input
            label="Description"
            value={values.desc}
            onChange={(e) => handleInputChange(e, "desc")}
            disabled={loading}
          />

          <Input
            label="Price"
            value={values.price}
            onChange={(e) => handleInputChange(e, "price")}
            disabled={loading}
          />

          <Input
            label="Category"
            value={values.category}
            onChange={(e) => handleInputChange(e, "category")}
            disabled={loading}
          />

          <Input
            label="Thumbnail"
            title={iconFileName}
            onChange={handleIconChange}
            type="file"
            disabled={loading}
          />

          {editMode ? (
            <Button
              loading={loading}
              style={{ width: "100%" }}
              onClick={() => handleEditItem && handleEditItem(values)}
            >
              Edit Item
            </Button>
          ) : (
            <Button
              loading={loading}
              style={{ width: "100%" }}
              onClick={() => handleCreateItem && handleCreateItem(values)}
            >
              Create Item
            </Button>
          )}
          <div style={{ color: "red", marginTop: "10px" }}>{error}</div>
        </Modal.Body>
      </Modal>
    </>
  );
};
